<template>
  <div>
    <el-row>
      <el-col span="16" :offset=4>
        <span style="font-size: 16px; font-weight:bold">{{name}} 设定参数</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col span="16" :offset=4>
        <el-select style="width: 100%;" v-model="operateType" @change="statusChange" size="small">
          <el-option key="0" label="开启" value="0">
          </el-option>
          <el-option key="1" label="关闭" value="1">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="operateType === '0'">
      <el-col span="16" :offset=4>
        <el-select style="width: 100%" v-model="turnLightType" size="small">
          <el-option key="0" label="左侧" value="Left">
          </el-option>
          <el-option key="1" label="右侧" value="Right">
          </el-option>
          <el-option key="2" label="双侧" value="Both">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="operateType === '0'" class="fs14">
      <el-col span="4" :offset=3>
        <span style="line-height: 32px;">频率：</span>
      </el-col>
      <el-col span="14" style="text-align: left;">
        <div>
          <span>亮</span>
          &nbsp;
          <el-select style="width: 65px" v-model="onTime" size="small">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          &nbsp;
          <span>秒(s)</span>
        </div>
        <div style="margin-top: 10px">
          <span>灭</span>
          &nbsp;
          <el-select style="width: 65px" v-model="offTime" size="small">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          &nbsp;
          <span>秒(s)</span>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="operateType === '0'">
      <el-col style="text-align: left;" span="16" :offset=4>
        <el-checkbox v-model="isFlow">是否添加亮时流水效果</el-checkbox>
      </el-col>
    </el-row>
    <el-row v-if="readonly === 0">
      <el-col span="16" :offset=4>
        <el-button type="primary" class="attr-window-button" round @click="save()">
          保存
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    readonly: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      operateType: '0',
      turnLightType: 'Left',
      onTime: 0,
      offTime: 0,
      isLoop: false,
      isFlow: false,
      options: [
        {
          value: '0.1',
          label: 0.1
        },
        {
          value: '0.2',
          label: 0.2
        },
        {
          value: '0.3',
          label: 0.3
        },
        {
          value: '0.4',
          label: 0.4
        },
        {
          value: '0.5',
          label: 0.5
        },
        {
          value: '0.6',
          label: 0.6
        },
        {
          value: '0.7',
          label: 0.7
        },
        {
          value: '0.8',
          label: 0.8
        },
        {
          value: '0.9',
          label: 0.9
        },
        {
          value: '1',
          label: 1
        },
        {
          value: '1.5',
          label: 1.5
        },
        {
          value: '2',
          label: 2
        },
        {
          value: '2.5',
          label: 2.5
        },
        {
          value: '3',
          label: 3
        },
        {
          value: '3.5',
          label: 3.5
        },
        {
          value: '4',
          label: 4
        },
        {
          value: '6',
          label: 6
        },
        {
          value: '8',
          label: 8
        },
        {
          value: '10',
          label: 10
        },
        {
          value: '15',
          label: 15
        },
        {
          value: '20',
          label: 20
        },
        {
          value: '25',
          label: 25
        },
        {
          value: '30',
          label: 30
        }
      ],
      returnStr: {
        data: {
          operateType: '',
          turnLightType: 0,
          isFlow: false,
          isLoop: false,
          onTime: 0.1,
          offTime: 0.1
        },
        nameText: ''
      }
    }
  },
  computed: {
    getProperty: function() {
      return this.value
    }
  },
  watch: {
    getProperty: {
      handler: function(newValue) {
        this.init()
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.value) {
        if (!this.value.data) {
          this.operateType = String(this.value.operateType)
          if (this.value.operateType === 0) {
            this.turnLightType = this.value.turnLightType
            this.isLoop = this.value.isLoop
            this.isFlow = this.value.isFlow
            this.onTime = !this.value.onTime ? 0.1 : this.value.onTime
            this.offTime = !this.value.offTime ? 0.1 : this.value.offTime
          }
        }
      }
    },
    statusChange(val) {
      if (this.operateType === '1') {
        this.turnLightType = 'Left'
        this.isLoop = false
        this.isFlow = false
        this.onTime = 0
        this.offTime = 0
      }
      else {
        this.turnLightType = 'Left'
        this.isLoop = false
        this.isFlow = false
        this.onTime = 0.1
        this.offTime = 0.1
      }
    },
    save() {
      this.returnStr.data.operateType = Number(this.operateType)
      this.returnStr.data.turnLightType = this.turnLightType
      this.returnStr.data.isLoop = true
      this.returnStr.data.isFlow = this.isFlow
      this.returnStr.data.onTime = this.onTime
      this.returnStr.data.offTime = this.offTime
      let nameText = ''
      if (this.operateType === '0') {
        nameText += ' 开'
        if (this.turnLightType === 'Left') {
          nameText += ' 左侧'
        }
        else if (this.turnLightType === 'Right') {
          nameText += ' 右侧'
        }
        else if (this.turnLightType === 'Both') {
          nameText += ' 双侧'
        }
        if (this.isFlow) {
          nameText += ' 流水'
        }
      }
      else {
        nameText += ' 关'
      }
      this.returnStr.nameText = this.name + nameText
      console.log(JSON.stringify(this.returnStr))
      this.$emit('callBackJson', this.returnStr)
    }
  }
}
</script>

<style scoped>
.el-row {
  text-align: center;
}
.el-row:not(:first-child) {
  margin-top: 16px;
}
.el-row:last-child {
  margin-top: 20px;
}
/deep/ .el-radio{
  display: block;
  line-height: 30px;
  white-space: normal;
  margin-right: 0;
}
.attr-window-button {
  width: 96px;
  height: 40px;
  background-color: #4D78FF;
  border-color: rgb(77, 120, 255);
}
.attr-window-button:hover {
  background-color: #355cd8;
}
/deep/ .el-input__inner {
  /* background-color: #131B25; */
  /* color:white ; */
}
/*/deep/ .el-select-dropdown {*/
/*  background-color: #131B25;*/
/*  color: white;*/
/*}*/
/*/deep/ .el-select-dropdown__item.hover {*/
/*  background-color: #4D78FF;*/
/*}*/
/*/deep/ .el-select-dropdown__item {*/
/*  color: #FFFFFF;*/
/*}*/
</style>
